import ProjectSkeleton from '@assets/images/project-skeleton.svg?react'
import type React from 'react'

import css from './styles.module.css'

export const PreviewSkeleton: React.FC = () => (
  <div className={css.skeleton_container}>
    <div className={css.gradient} />
    <ProjectSkeleton className={css.image} />
  </div>
)
